import FJImageManipulationLeft from '../view/FJImageManipulationLeft';
import { useDispatch, useSelector } from 'react-redux';
import useLocalStore from '../../../../hooks/useLocalStore';
import FJActionImageManipulation from '../../../../redux/action/FJActionImageManipulation';
import { useCallback } from 'react';
import { setSliceSwitchOldPhotoRestorationAction } from '../../../../redux/slices/FJSliceImageManipulation';
import FJUtil from '../../../../util/FJUtil';
import FJActionCommon from '../../../../redux/action/FJActionCommon';
import FJConstant from '../../../../constants/FJConstant.js';
const FJImageManipulationLeftContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();

    const switchOldPhotoRestoration = useSelector(state => state.imageManipulation.switchOldPhotoRestoration);
    const taskStatus = useSelector(state => state.common.taskStatus);
    const creditNumber = useSelector(state => state.common.creditNumber);
    const freeNumCreation = useSelector(state => state.common.freeNumCreation);
    const isProjectLoading = useSelector(state => state.common.isProjectLoading);
    const imageEnhancerActive = useSelector(state => state.imageManipulation.imageEnhancerData.switch);

    const onSwitchOldPhotoRestoration = value => {
        dispatch(setSliceSwitchOldPhotoRestorationAction(value));
    };

    const _onGenerate = useCallback(() => {
        if (FJUtil.isGeneratingStatus(taskStatus)) return;
        dispatch(FJActionImageManipulation.generateAction());
        dispatch(FJActionCommon.setHeaderTabIndexAction(FJConstant.CREATIONS));
    }, [dispatch, taskStatus]);

    return (
        <FJImageManipulationLeft
            switchOldPhotoRestoration={switchOldPhotoRestoration}
            onSwitchOldPhotoRestoration={onSwitchOldPhotoRestoration}
            creditNumber={creditNumber}
            taskStatus={taskStatus}
            onGenerate={_onGenerate}
            freeNumCreation={freeNumCreation}
            isProjectLoading={isProjectLoading}
            imageEnhancerActive={imageEnhancerActive}
        />
    );
};
export default FJImageManipulationLeftContainer;
